import React from 'react';
import { Button, Modal, message } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import AcceptEstimateMutation from '../../../mutations/estimate/AcceptEstimateMutation';
import DeclineEstimateMutation from '../../../mutations/estimate/DeclineEstimateMutation';
import { EstimateDeclineReason } from '../../../mutations/estimate/__generated__/DeclineEstimateMutation.graphql';
import DeclineModalForm, {
  DeclineModalFormRef,
} from '../../../components/Estimate/DeclineModalForm';

import styles from './index.module.less';

const { confirm } = Modal;

export type ActionHeaderProps = {
  estimate: { webToken: string };
};

function ActionHeader(props: ActionHeaderProps) {
  const [showModal, setShowModal] = React.useState<boolean>(false);
  const [confirmLoading, setConfirmLoading] = React.useState(false);
  const declineFormRef = React.useRef<DeclineModalFormRef>(null);

  function showConfirm() {
    confirm({
      title: 'Möchten Sie das Angebot wirklich annehmen?',
      okText: 'Annehmen',
      cancelText: 'Abbrechen',
      onOk() {
        return new Promise<void>((resolve) => {
          AcceptEstimateMutation(props.estimate.webToken, (estimate) => {
            if (estimate) {
              message.success('Angebot erfolgreich angenommen');
            } else {
              message.error('Fehler beim Annehmen des Angebots');
            }
            resolve();
          });
        });
      },
    });
  }

  function onShowModal() {
    setShowModal(true);
  }

  function onCloseModal() {
    setShowModal(false);
  }

  async function handleDecline() {
    if (!declineFormRef.current) {
      return;
    }

    try {
      const values = await declineFormRef.current.validateFields();
      setConfirmLoading(true);
      DeclineEstimateMutation(
        props.estimate.webToken,
        values.reason as EstimateDeclineReason,
        values.note,
        (estimate) => {
          declineFormRef.current?.resetFields();
          setShowModal(false);
          setConfirmLoading(false);

          if (estimate) {
            message.success('Angebot erfolgreich abgelehnt');
          } else {
            message.error('Fehler beim Ablehnen des Angebots');
          }
        }
      );
    } catch {
      // Validation failed, do nothing
    }
  }

  return (
    <div className={styles.actionButtons}>
      <Button
        className={styles.btnAccept}
        type='primary'
        size='large'
        onClick={showConfirm}
        icon={<CheckOutlined />}
      >
        <span className={styles.btnText}>Annehmen</span>
      </Button>
      <Button
        className={styles.btnDecline}
        type='primary'
        size='large'
        onClick={onShowModal}
        icon={<CloseOutlined />}
      >
        <span className={styles.btnText}>Ablehnen</span>
      </Button>
      <DeclineModalForm
        ref={declineFormRef}
        open={showModal}
        onDecline={handleDecline}
        onCancel={onCloseModal}
        confirmLoading={confirmLoading}
      />
    </div>
  );
}

export default ActionHeader;
